import { useContext } from 'react';
import { ActiveEventsContext } from './ActiveEventsContext';

export function useActiveEventsContext() {
  return useContext(ActiveEventsContext);
}
